/* eslint-disable react-hooks/exhaustive-deps */
import { Affix, Button, Checkbox, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import DataFlowService from '../../../../services/DataFlow.service';
import RopaService from '../../../../services/Ropa.service';
import { useBlocker } from '../../../../util/usePrompt';
import { useNavigate, useParams } from 'react-router-dom';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import useNotify from '../../../../context/Notification/useNotify';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import { ROUTER } from '../../../../constants/router';

const { TextArea } = Input;

const Tab1 = ({ collectData, getRopaDetail }) => {
    const { t, i18n } = useTranslation();
    let { activityId } = useParams();
    const lang = i18n.language;
    const [form] = Form.useForm();
    // const [addonYear, setAddonYear] = useState(undefined);
    const [checkOrganize, setCheckOrganize] = useState([false, false]);
    const [checkTransfer, setCheckTransfer] = useState([false, false]);
    const [checkDataSource, setCheckDataSource] = useState([false, false]);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const [dataSubject, setDataSubject] = useState([]);
    const [organizeDataCollection, setOrganizeDataCollection] = useState([]);
    const [amountDataYear, setAmountDataYear] = useState([]);
    const [lawfullbasis, setLawfullbasis] = useState([]);
    const [lawFullBasisSensitiveList, setLawFullBasisSensitiveList] = useState(
        []
    );

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    const Navigate = useNavigate();
    const notify = useNotify();

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await getRopaDetail();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const getDataSubject = async () => {
            const { data } = await RopaService.getDataSubject(activityId);
            if (data.resultData) {
                setDataSubject(data.resultData);
            }
        };
        const getOrganizeDataCollection = async () => {
            const { data } = await RopaService.getOrganizeDataCollection(
                activityId
            );
            if (data.resultData) {
                setOrganizeDataCollection(data.resultData);
            }
        };

        const getAmountDataYear = async () => {
            const { data } = await DataFlowService.getAmountDataYear();
            if (data.resultData) {
                setAmountDataYear(data.resultData);
            }
        };
        const getLawFullBasis = async () => {
            const { data } = await DataFlowService.getLawFullBasis('general');
            if (data.resultData) {
                setLawfullbasis(data.resultData);
            }
        };
        const getLawFullBasisSensitive = async () => {
            const { data } = await DataFlowService.getLawFullBasis('sensitive');
            if (data.resultData) {
                setLawFullBasisSensitiveList(data.resultData);
            }
        };

        getLawFullBasisSensitive();
        getDataSubject();
        getOrganizeDataCollection();
        getAmountDataYear();
        getLawFullBasis();
    }, []);

    const onSubmit = async () => {
        try {
            const { data } = await RopaService.updateCollectData({
                activityId: activityId,
                collectData: {
                    dataSubject: valueSave.dataSubject, //เจ้าของข้อมูล
                    dataSource: checkDataSource[0],
                    anotherDataSource: checkDataSource[1], //เจ้าของข้อมูล
                    organizeDataCollection: valueSave.organizeDataCollection, //หน่วยงานผู้รับผิดชอบในการจัดเก็บข้อมูล
                    organizeUseDataInSide: checkOrganize[0],
                    organizeUseDataOutSide: checkOrganize[1],
                    dataTransferInSide: checkTransfer[0],
                    dataTransferOutSide: checkTransfer[1],
                    notHaveOrganizeUseData: collectData?.notHaveOrganizeUseData,
                    notHaveDataTransfer: collectData?.notHaveDataTransfer,
                },
            });
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
                setOpenChange(false);
                setChange(false);
                setLoading(false);
                setOpenConfirm(false);
                Navigate(
                    `${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=1`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
                setOpenConfirm(false);
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    useEffect(() => {
        if (change === 3) {
            changePage();
        }
    }, [change]);

    const changePage = () => {
        Navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=1`);
    };

    useEffect(() => {
        if (collectData) {
            // if (collectData?.amountDataYear === 'addon') {
            //     setAddonYear(collectData?.amountDataYear);
            // }
            setCheckDataSource([
                collectData?.dataSource,
                collectData?.anotherDataSource,
            ]);
            setCheckOrganize([
                collectData?.organizeUseDataInSide,
                collectData?.organizeUseDataOutSide,
            ]);
            setCheckTransfer([
                collectData?.dataTransferInSide,
                collectData?.dataTransferOutSide,
            ]);
            form.setFieldsValue({
                ...collectData,
                data: [
                    collectData?.dataSource && 'dataSource',
                    collectData?.anotherDataSource && 'anotherDataSource',
                ],
                organize: [
                    collectData?.organizeUseDataInSide &&
                        'organizeUseDataInSide',
                    collectData?.organizeUseDataOutSide &&
                        'organizeUseDataOutSide',
                    collectData?.notHaveOrganizeUseData &&
                        'notHaveOrganizeUseData',
                ],
                transfer: [
                    collectData?.dataTransferInSide && 'dataTransferInSide',
                    collectData?.dataTransferOutSide && 'dataTransferOutSide',
                    collectData?.notHaveDataTransfer && 'notHaveDataTransfer',
                ],
            });
            // form.setFieldsValue();
        }
    }, [collectData]);

    const getLawFullBasisName = (id) => {
        if (id && lawfullbasis?.length > 0) {
            const result = lawfullbasis.filter(
                (data) => data.lawfulBasisId === id
            );
            return (
                <p key={id} className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.lawfulBasisNameEn
                        : result[0]?.lawfulBasisNameTh}
                </p>
            );
        }
    };

    const getLawFullBasisSenName = (id) => {
        if (id && lawFullBasisSensitiveList?.length > 0) {
            const result = lawFullBasisSensitiveList.filter(
                (data) => data.lawfulBasisId === id
            );
            return (
                <p key={id} className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.lawfulBasisNameEn
                        : result[0]?.lawfulBasisNameTh}
                </p>
            );
        }
    };

    const getAmountDataYearName = (id) => {
        if (id && amountDataYear?.length > 0) {
            const result = amountDataYear.filter(
                (data) => data.statusId === id
            );
            return (
                <p key={id} className="mb-0">
                    &#8226;{' '}
                    {i18n.language === 'en'
                        ? result[0]?.nameEn
                        : result[0]?.nameTh}
                </p>
            );
        }
    };

    const lawGroupGen = collectData?.lawfulBasis?.find(
        (lawGroup) => lawGroup.lawGroup === 'general'
    );
    const lawGroupSen = collectData?.lawfulBasis?.find(
        (lawGroup) => lawGroup.lawGroup === 'sensitive'
    );

    return (
        <>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={(value) => {
                    setOpenConfirm(true);
                    setValueSave(value);
                }}
                onFinishFailed={(value) => {
                    console.log('value failed', value);
                }}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
                // initialValues={{ organizeDataCollection: [''] }}
            >
                <Affix offsetTop={60}>
                    <div className="flex justify-end space-x-3">
                        <Button
                            size="large"
                            type="default"
                            className="text-purple-PHX border-purple-PHX w-32"
                            onClick={changePage}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            size="large"
                            type="primary"
                            className="w-32"
                            htmlType="submit"
                        >
                            {t('common.Save')}
                        </Button>
                    </div>
                </Affix>
                <Form.Item
                    className="mt-4"
                    name="dataSubject"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.dataSubject')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full mb-1">
                        {dataSubject.map((is) => {
                            return (
                                <div key={is.id}>
                                    <Checkbox
                                        value={is.id}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {lang === 'en' ? is.nameEn : is.nameTh}
                                    </Checkbox>
                                    <br />
                                </div>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>

                <div className="text-[21px] font-bold">
                    {t('dataFlow.amountDataYear')}
                </div>
                {collectData?.amountDataYear &&
                collectData?.amountDataYear !== 'addon' ? (
                    getAmountDataYearName(collectData.amountDataYear)
                ) : collectData?.amountDataYearAddOn ? (
                    <p className="mb-0">
                        &#8226; {collectData.amountDataYearAddOn}
                    </p>
                ) : (
                    ''
                )}

                <Form.Item
                    className="mt-4"
                    name="organizeDataCollection"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.organizeDataCollection')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full mb-1">
                        {organizeDataCollection.map((is) => {
                            return (
                                <div key={is.id}>
                                    <Checkbox
                                        key={is.id}
                                        value={is.id}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {lang === 'en' ? is.name : is.name}
                                    </Checkbox>
                                    <br />
                                </div>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    name="reasonNecessity"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.reasonNecessity')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <TextArea
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                        disabled={true}
                    />
                </Form.Item>

                <div className="text-[21px] font-bold">
                    {t('dataFlow.lawfulBasis')}
                </div>
                {lawGroupGen
                    ? lawGroupGen?.relatedLaw.map((item) =>
                          getLawFullBasisName(item)
                      )
                    : '-'}

                <div className="text-[21px] font-bold mt-4">
                    {t('dataFlow.lawfulBasisSensitivity')}
                </div>
                {lawGroupSen?.relatedLaw?.length > 0
                    ? lawGroupSen?.relatedLaw.map((item) =>
                          getLawFullBasisSenName(item)
                      )
                    : '-'}

                <Form.Item
                    className="mt-4"
                    name="data"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.dataSource')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full">
                        <Checkbox
                            value="dataSource"
                            onChange={() =>
                                setCheckDataSource([
                                    !checkDataSource[0],
                                    checkDataSource[1],
                                ])
                            }
                        >
                            {t('dataFlow.optionlawfull')}
                        </Checkbox>
                        {checkDataSource[0] && (
                            <div
                                style={{ background: '#EDEEF9' }}
                                className="p-4 rounded-md ml-5 mt-4"
                            >
                                <Form.Item
                                    name="dataSourceDetail"
                                    label={
                                        <span className="text-[14px]">
                                            {t('dataFlow.inputpl4')}
                                        </span>
                                    }
                                >
                                    <TextArea
                                        disabled
                                        size="large"
                                        className="bg-white"
                                        rows={4}
                                        placeholder={t('dataFlow.inputpl3')}
                                    />
                                </Form.Item>
                            </div>
                        )}
                        <br />
                        <div hidden={!collectData?.anotherDataSourceDetail}>
                            <Checkbox
                                value="anotherDataSource"
                                onChange={() =>
                                    setCheckDataSource([
                                        checkDataSource[0],
                                        !checkDataSource[1],
                                    ])
                                }
                            >
                                {t('dataFlow.optionlawAnother')}
                            </Checkbox>
                        </div>
                        {checkDataSource[1] && (
                            <div
                                style={{ background: '#EDEEF9' }}
                                className="p-4 rounded-md ml-5 my-4"
                            >
                                <Form.Item
                                    name="anotherDataSourceDetail"
                                    label={
                                        <span className="text-[14px]">
                                            {t('dataFlow.inputpl4')}
                                        </span>
                                    }
                                >
                                    <TextArea
                                        disabled
                                        size="large"
                                        className="bg-white"
                                        rows={4}
                                        placeholder={t('dataFlow.inputpl3')}
                                    />
                                </Form.Item>
                            </div>
                        )}
                    </Checkbox.Group>
                </Form.Item>

                <Form.Item
                    name="processUseData"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.processUseData')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <TextArea
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                        disabled={true}
                    />
                </Form.Item>

                <Form.Item
                    className="mt-4"
                    name="organize"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.Organize')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full">
                        {collectData?.organizeUseDataInSide && (
                            <Checkbox
                                value="organizeUseDataInSide"
                                onChange={() =>
                                    setCheckOrganize([
                                        !checkOrganize[0],
                                        checkOrganize[1],
                                    ])
                                }
                            >
                                {t('dataFlow.inside')}
                            </Checkbox>
                        )}
                        {checkOrganize[0] && (
                            <>
                                <div
                                    style={{ background: '#EDEEF9' }}
                                    className="p-4 rounded-md ml-5 mt-4"
                                >
                                    <Form.Item
                                        name="organizeUseDataInSideDetail"
                                        label={
                                            <span className="text-[14px]">
                                                {t('dataFlow.inputpl4')}
                                            </span>
                                        }
                                    >
                                        <TextArea
                                            size="large"
                                            className="bg-white"
                                            rows={4}
                                            placeholder={t('dataFlow.inputpl3')}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>
                                <br />
                            </>
                        )}
                        {collectData?.organizeUseDataOutSide && (
                            <Checkbox
                                value="organizeUseDataOutSide"
                                onChange={() =>
                                    setCheckOrganize([
                                        checkOrganize[0],
                                        !checkOrganize[1],
                                    ])
                                }
                            >
                                {t('dataFlow.outside')}
                            </Checkbox>
                        )}
                        {checkOrganize[1] && (
                            <>
                                <div
                                    style={{ background: '#EDEEF9' }}
                                    className="p-4 rounded-md ml-5 my-4"
                                >
                                    <Form.Item
                                        name="organizeUseDataOutSideDetail"
                                        label={
                                            <span className="text-[14px]">
                                                {t('dataFlow.inputpl4')}
                                            </span>
                                        }
                                    >
                                        <TextArea
                                            size="large"
                                            className="bg-white"
                                            rows={4}
                                            placeholder={t('dataFlow.inputpl3')}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>
                                <br />
                            </>
                        )}

                        {collectData?.notHaveOrganizeUseData && (
                            <Checkbox value="notHaveOrganizeUseData">
                                {t('No other department uses the information')}
                            </Checkbox>
                        )}
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="transfer"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.Transfer')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full">
                        {collectData?.dataTransferInSide && (
                            <Checkbox
                                value="dataTransferInSide"
                                onChange={() =>
                                    setCheckTransfer([
                                        !checkTransfer[0],
                                        checkTransfer[1],
                                    ])
                                }
                            >
                                {t('dataFlow.inside')}
                            </Checkbox>
                        )}
                        {checkTransfer[0] && (
                            <>
                                <div
                                    style={{ background: '#EDEEF9' }}
                                    className="p-4 rounded-md ml-5 mt-4"
                                >
                                    <Form.Item
                                        name="dataTransferInSideDetail"
                                        label={
                                            <span className="text-[14px]">
                                                {t('dataFlow.inputpl4')}
                                            </span>
                                        }
                                    >
                                        <TextArea
                                            size="large"
                                            className="bg-white"
                                            rows={4}
                                            placeholder={t('dataFlow.inputpl3')}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>
                                <br />
                            </>
                        )}

                        {collectData?.dataTransferOutSide && (
                            <Checkbox
                                value="dataTransferOutSide"
                                onChange={() =>
                                    setCheckTransfer([
                                        checkTransfer[0],
                                        !checkTransfer[1],
                                    ])
                                }
                            >
                                {t('dataFlow.outside')}
                            </Checkbox>
                        )}
                        {checkTransfer[1] && (
                            <>
                                <div
                                    style={{ background: '#EDEEF9' }}
                                    className="p-4 rounded-md ml-5 my-4"
                                >
                                    <Form.Item
                                        name="dataTransferOutSideDetail"
                                        label={
                                            <span className="text-[14px]">
                                                {t('dataFlow.inputpl4')}
                                            </span>
                                        }
                                    >
                                        <TextArea
                                            size="large"
                                            className="bg-white"
                                            rows={4}
                                            placeholder={t('dataFlow.inputpl3')}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="purposeDataTransferOutSideDetail"
                                        label={
                                            <span className="text-[14px]">
                                                {t('dataFlow.inputpl5')}
                                            </span>
                                        }
                                    >
                                        <TextArea
                                            size="large"
                                            className="bg-white"
                                            rows={4}
                                            placeholder={t('dataFlow.inputpl3')}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                </div>
                                <br />
                            </>
                        )}

                        {collectData?.notHaveDataTransfer && (
                            <Checkbox value="notHaveDataTransfer">
                                {t('Not transferred to any department')}
                            </Checkbox>
                        )}
                    </Checkbox.Group>
                </Form.Item>
                <Form.Item
                    name="discloseToOtherPerson"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.discloseToOtherPerson')}
                        </span>
                    }
                >
                    <TextArea
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                        disabled={true}
                    />
                </Form.Item>
                <div className="mb-1">
                    <span className="text-[21px] font-bold ant-form-item-required">
                        {t('dataFlow.RightsAndMethodsOfAccessToPersonalData')}
                    </span>
                </div>
                <Form.Item name="rightsAndConditionPersonalData">
                    <TextArea
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                        disabled={true}
                    />
                </Form.Item>
                <Form.Item
                    name="useOrDisclosurePersonalDataExceptConsent"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.UseOrDisclosureOfPersonalInformation')}
                        </span>
                    }
                >
                    <TextArea
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                        disabled={true}
                    />
                </Form.Item>
                <Form.Item
                    name="securityMeasureUnder37"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.PersonalDataSecurityMeasures')}
                        </span>
                    }
                >
                    <TextArea
                        size="large"
                        rows={4}
                        placeholder={t('dataFlow.inputpl3')}
                        disabled={true}
                    />
                </Form.Item>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
        </>
    );
};

export default Tab1;
